<template>
  <div style="position: relative;">
    <div
      :class="{
        line: (!$vuetify.breakpoint.xs && !cardFilho) || (!mobile && !cardFilho),
        'line-especial': cardFilho && index === 0,
        'line-especial-segundo': cardFilho && index > 0
      }"
      :style="objetoEstilo"
      v-if="!currentUnit"
    />
    <div :class="{ 'mb-8': cardFilho }" class="card naoSelecionavel subtitle-2" v-if="!currentUnit && !comboBox">
      <p class="text">
        <span class="primary1--text">{{ unidadeID }} -</span><span> {{ unidadeName }}</span>
      </p>
      <p class="text"><span class="primary1--text">Tipo de Cooperativa:</span> {{ tipoCooperativa }}</p>
      <p class="text"><span class="primary1--text">Tipo de Atuação:</span> {{ tipoAtuacao }}</p>
    </div>

    <div v-else-if="comboBox" class="card naoSelecionavel subtitle-2">
      <validation-provider ref="hierarquiaAuto" mode="eager" rules="required" v-slot="{ errors }">
        <autocomplete-cadu
          :items="listaUnimeds.map((el) => el.textoExibicao)"
          title="Buscar Unimed"
          v-model="valueData"
          @input="nomeAcima"
          @index="indexAcima"
          :errorMessage="errors[0]"
        />
      </validation-provider>
      <p class="text"><span class="primary1--text">Tipo de Cooperativa:</span> {{ tipoCooperativa }}</p>
      <p class="text"><span class="primary1--text">Tipo de Atuação:</span> {{ tipoAtuacao }}</p>
    </div>

    <div class="current-card naoSelecionavel subtitle-2" v-else>
      <p class="text">
        <v-tooltip v-if="unidadeName.length > 30" top max-width="300">
          <template v-slot:activator="{ on }">
            <div v-on="on" style="display: inline;">
              {{ getTextTooltip }}
            </div>
          </template>

          <span>{{ unidadeID }} - {{ unidadeName }}</span>
        </v-tooltip>

        <span v-else>{{ unidadeID }} - {{ unidadeName }}</span>
      </p>

      <p class="text">Tipo de Cooperativa: {{ tipoCooperativa }}</p>
      <p class="text">Tipo de Atuação: {{ tipoAtuacao }}</p>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'HierarquiaCard',
  components: {
    ValidationProvider
  },
  props: {
    currentUnit: {
      type: Boolean,
      required: true,
      default: false
    },
    unidadeID: {
      type: Number,
      required: false,
      default: 0
    },
    unidadeName: {
      type: String,
      required: false,
      default: ''
    },
    tipoCooperativa: {
      type: String,
      required: false,
      default: ''
    },
    tipoAtuacao: {
      type: String,
      required: false,
      default: ''
    },
    cardPai: {
      type: Boolean,
      required: false,
      default: false
    },
    cardFilho: {
      type: Boolean,
      required: false,
      default: false
    },
    index: {
      type: Number
    },
    mobile: {
      type: Boolean,
      required: false,
      default: false
    },
    comboBox: {
      type: Boolean,
      required: false,
      default: false
    },
    listaUnimeds: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      left: '0px',
      top: '0px',
      objPai: {
        left: '104px',
        top: '154px',
        width: '207px',
        height: '100px'
      },
      objFilho: {
        height: '37%',
        width: '115%'
      },
      objFilhoDois: {
        width: '100px',
        height: '1px'
      },
      unimedPai: {
        nome: '',
        id: ''
      },
      valueData: this.value
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },

  methods: {
    async validate() {
      const res = await this.$refs.hierarquiaAuto.validate()
      return res.valid
    },
    nomeAcima(input) {
      this.unimedPai.nome = input
    },
    async indexAcima(index) {
      await this.$nextTick()
      this.unimedPai.id = index !== null && index > -1 ? this.listaUnimeds[index].id : ''
      if (this.unimedPai.id && this.unimedPai.nome !== this.value) {
        this.$emit('input', await this.unimedPai)
      }
    },
    getWindowWidth(event) {
      let width = this.$el.clientWidth
      this.width = this.addPx(width)
      this.left = this.addPx(Math.round(width / 2))

      this.objFilho.left = this.addPx(Math.round(width / 10) * -1)
      this.objFilho.width = this.addPx(width * 1.17)

      this.objFilhoDois.width = this.addPx(width * 2.125)
      this.objFilhoDois.right = this.addPx(Math.round(width / 2) * -1)
    },

    getWindowHeight(event) {
      let height = this.$el.clientHeight
      this.height = height
      this.top = this.addPx(height)

      this.objFilho.height = this.addPx(60)
      this.objFilho.bottom = this.addPx(42 * -1)

      this.objFilhoDois.height = this.addPx(height)
      this.objFilhoDois.bottom = this.addPx(Math.round(height) * 1.135)
    },
    addPx(num) {
      return `${num}px`
    }
  },
  computed: {
    objetoEstilo() {
      if (this.cardPai && !this.cardFilho) {
        return { border: 'none' }
      } else if (this.cardFilho && this.index === 0) {
        return this.objFilho
      } else if (this.cardFilho && this.index > 0) {
        return this.objFilhoDois
      }
      return { left: this.left, top: this.top, width: this.width }
    },

    getTextTooltip() {
      return `${this.unidadeID} - ${this.unidadeName.substring(0, 16)}...`
    }
  }
}
</script>

<style scoped>
.card {
  width: 100%;
  min-height: 121px;
  background-color: #ffffff;
  border: 1px solid #00995d;
  border-radius: 5px;
  padding: 15px 5px 5px 10px;
  position: relative;
  z-index: 5;
}

.card .text {
  margin: 0;
  text-align: left;
  letter-spacing: 0;
  color: #9e9e9e;
  opacity: 1;
}

.line {
  border: #00995d solid 1px;
  width: 132px;
  height: 10px;
  position: absolute;
  left: 100px;
  top: 121px;
  border-top: none;
  border-right: none;
}

@media (max-width: 1320px) {
  .line {
    width: 132px;
  }
}
@media (min-width: 1320px) {
  .line {
    width: 330px;
  }
}

.highlight {
  color: #00995d;
}

.current-card {
  width: 100%;
  min-height: 121px;
  background-color: #00995d;
  border: 1px solid #ffffff;
  border-radius: 5px;
  padding: 15px 5px 5px 10px;
}

.current-card .text {
  margin: 0;
  text-align: left;
  font: Regular 11px/25px Trebuchet MS;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.line-especial {
  border: 1px solid #00995d;
  position: absolute;
  background: white;
  z-index: 1;
}

.line-especial-segundo {
  border-bottom: 1px solid #00995d;
  position: absolute;
  z-index: 0;
  border-left: 1px solid #00995d;
}
</style>
